module.exports = __webpack_public_path__ + "static/media/clients-05.79cb9a52.svg";